import React from 'react';
import { useFormValue } from 'hooks/useFormValue';
import { useFormState } from 'react-hook-form';
import { usePasswordChangePageBLoC } from '../../PasswordChangePage.bloc';
import { PasswordsChangeFormStyle as S } from './PasswordsChangeForm.style';
import { USER_PASSWORD_MAX_LENGTH, validateUserPassword } from 'utils/validateUserPassword';
import { PasswordInput } from 'components/PasswordInput/PasswordInput';
import { FormField } from 'components/FormField/FormField';
import { VStack } from 'components/layouts/primitives/Stack/Stack';

export const PasswordsChangeForm: React.FC = () => {
  const { form, handleSubmit } = usePasswordChangePageBLoC();
  const password = useFormValue(form, 'password');
  const email = useFormValue(form, 'email');
  const formState = useFormState(form);

  return (
    <S.Form>
      <form onSubmit={handleSubmit}>
        <VStack gap="gap5">
          <FormField
            controller={{
              name: 'password',
              rules: {
                required: true,
                validate: (value: string) => {
                  const { hasErrors, firstErrorMessage } = validateUserPassword(value, {
                    email: email || '',
                  });
                  return !hasErrors || firstErrorMessage || true;
                },
              },
            }}
            form={form}
            label="New password"
          >
            {({ field, fieldState }) => (
              <PasswordInput
                {...field}
                onBlur={() => {
                  form.formState.touchedFields['passwordConfirmation'] &&
                    form.trigger('passwordConfirmation');
                  field.onBlur();
                }}
                invalid={fieldState.invalid}
                maxLength={USER_PASSWORD_MAX_LENGTH}
                placeholder="New password must be at least 20 characters"
                data-testid="input-change-password-new"
              />
            )}
          </FormField>
          <FormField
            controller={{
              name: 'passwordConfirmation',
              rules: {
                required: true,
                validate: (value) => {
                  return password === value ? true : 'Passwords must match';
                },
              },
            }}
            form={form}
            label="Confirm new password"
          >
            {({ field, fieldState }) => (
              <PasswordInput
                {...field}
                invalid={fieldState.invalid}
                placeholder="Confirm new password"
                data-testid="input-change-password-confirm"
              />
            )}
          </FormField>
          <S.Message
            severity="info"
            content="Avoid using personal information such as names, emails, or common phrases."
          />
        </VStack>
        <S.Button
          label="Update password"
          type="submit"
          disabled={!formState.isValid}
          data-testid="input-change-password-update"
        />
      </form>
    </S.Form>
  );
};
